/**
 * Passaporto del Custode — dati timbri araldici + geo + storage locale.
 * Simulazione frontend (localStorage) in attesa dell'integrazione account.
 */

export const RAGGIO_SBLOCCO_KM = 1.5;
export const PASSAPORTO_KEY = "passaporto_custode_v1";

/** Borghi timbrabili: coordinate centro abitato + livrea araldica dello scudetto. */
export const BORGHI_TIMBRO = [
  {
    slug: "assisi",
    nome: "Assisi",
    prov: "PG",
    regione: "Umbria",
    punti: 60,
    coords: { lat: 43.0707, lng: 12.6196 },
    scudetto: { pattern: "cross", c1: "#ece7db", c2: "#a1231f", symbol: "🕊️" },
  },
  {
    slug: "civitella-del-tronto",
    nome: "Civitella del Tronto",
    prov: "TE",
    regione: "Abruzzo",
    punti: 50,
    coords: { lat: 42.7717, lng: 13.6658 },
    scudetto: { pattern: "paly", c1: "#1e4d8c", c2: "#d4af37", symbol: "🏰" },
  },
  {
    slug: "castelli",
    nome: "Castelli",
    prov: "TE",
    regione: "Abruzzo",
    punti: 50,
    coords: { lat: 42.4856, lng: 13.7103 },
    scudetto: { pattern: "fess", c1: "#f5f0e6", c2: "#2b5ea7", symbol: "🏺" },
  },
  {
    slug: "offida",
    nome: "Offida",
    prov: "AP",
    regione: "Marche",
    punti: 50,
    coords: { lat: 42.9356, lng: 13.6914 },
    scudetto: { pattern: "bend", c1: "#a1231f", c2: "#d4af37", symbol: "🧵" },
  },
  {
    slug: "montorio-al-vomano",
    nome: "Montorio al Vomano",
    prov: "TE",
    regione: "Abruzzo",
    punti: 45,
    coords: { lat: 42.5824, lng: 13.6344 },
    scudetto: { pattern: "chief", c1: "#2f6b3a", c2: "#ece7db", symbol: "⛰️" },
  },
  {
    slug: "campli",
    nome: "Campli",
    prov: "TE",
    regione: "Abruzzo",
    punti: 50,
    coords: { lat: 42.7272, lng: 13.6877 },
    scudetto: { pattern: "paly", c1: "#a1231f", c2: "#ece7db", symbol: "🏛️" },
  },
];

/** Distanza haversine in km. */
export function distanzaKm(a, b) {
  const R = 6371;
  const dLat = ((b.lat - a.lat) * Math.PI) / 180;
  const dLng = ((b.lng - a.lng) * Math.PI) / 180;
  const s =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((a.lat * Math.PI) / 180) *
      Math.cos((b.lat * Math.PI) / 180) *
      Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(s));
}

/** Borgo timbrabile più vicino alla posizione (o null). */
export function borgoPiuVicino(lat, lng) {
  let best = null;
  for (const b of BORGHI_TIMBRO) {
    const d = distanzaKm({ lat, lng }, b.coords);
    if (!best || d < best.distanza) best = { borgo: b, distanza: d };
  }
  return best;
}

export function leggiPassaporto() {
  try {
    const raw = window.localStorage.getItem(PASSAPORTO_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

/** Persiste lo sblocco e notifica i componenti aperti (album + pannello). */
export function salvaTimbro(slug) {
  const stato = leggiPassaporto();
  if (stato[slug]) return stato;
  stato[slug] = Date.now();
  try {
    window.localStorage.setItem(PASSAPORTO_KEY, JSON.stringify(stato));
  } catch {
    /* storage pieno o bloccato: lo stato resta in memoria */
  }
  window.dispatchEvent(new CustomEvent("passaporto:update"));
  return stato;
}

export function formatDataTimbro(ts) {
  try {
    return new Date(ts).toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  } catch {
    return "";
  }
}
